import { Sprite, Text, TextStyle } from "pixi.js";
import { CommonResourcesPackage } from "../resources/CommonResourcesPackage";
import { GameFont } from "../GameFont";

export class PiggyMultiplier extends Sprite {
    private readonly multiplierText: Text;

    public constructor(commonResources: CommonResourcesPackage) {
        super(commonResources.assets_common_ui_piggy_icon_without_mp_png);
        this.multiplierText = new Text(`+?`, new MultiplierTextStyle());
        this.multiplierText.position.set(this.width * 0.5 - this.multiplierText.width * 0.5 - 1, this.height * 0.5 - this.multiplierText.height * 0.5 + 3);
        this.addChild(this.multiplierText);
    }
}

class MultiplierTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 46,
            fill: 'FFFFFF'
        });
    }
}
